import React from 'react';
import { ShopTileProps } from './shop-tile.types';
import { ShopTileCompact } from '../shop-tile-compact';
import { ShopTileDetailed } from '../shop-tile-detailed';

const ShopTile: React.FC<ShopTileProps> = React.memo(
  ({ type = 'COMPACT', shop, onRouterClick, layout = 'HORIZONTAL', disableAnimation }) => {
    if (type === 'COMPACT') {
      return (
        <ShopTileCompact
          shop={shop}
          onRouterClick={onRouterClick}
          layout={layout}
          disableAnimation={disableAnimation}
        />
      );
    }

    return <ShopTileDetailed shop={shop} onRouterClick={onRouterClick} disableAnimation={disableAnimation} />;
  }
);

export default ShopTile;
